import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import equalHousingOpportunityImage from './equal-housing-opportunity.svg'
import equalHousingLenderImage from './equal-housing-lender.svg'
import equalOpportunityLenderImage from './equal-opportunity-lender.png'
import { Image, Text } from '@homebotapp/hb-react-component-catalog'
import { selectCorporateProfile } from '../../../store/selectors/customerProfile'

const imagePropsForType = {
  equal_opportunity_lender: {
    src: equalOpportunityLenderImage,
    alt: 'Equal Opportunity Lender'
  },
  lender: {
    src: equalHousingLenderImage,
    alt: 'Equal Housing Lender'
  },
  opportunity: {
    src: equalHousingOpportunityImage,
    alt: 'Equal Housing Opportunity'
  }
}

export const HousingType = () => {
  const corporateProfile = useSelector(selectCorporateProfile) || {}
  const { equalHousingType } = corporateProfile
  const imageProps = imagePropsForType[equalHousingType]

  if (!imageProps) {
    return null
  }

  return (
    <>
      <Image src={imageProps.src} alt={imageProps.alt} height={75} width={75} />
      <Text mt={4} size='2xs'>
        {equalHousingType === 'opportunity' && (
          <FormattedMessage id='Disclaimer.equalHousing.opportunity' defaultMessage='Equal Housing Opportunity.' />
        )}
        {equalHousingType === 'lender' && (
          <FormattedMessage id='Disclaimer.equalHousing.lender' defaultMessage='Equal Housing Lender.' />
        )}
        {equalHousingType === 'equal_opportunity_lender' && (
          <FormattedMessage
            id='Disclaimer.equalHousing.equal_opportunity_lender'
            defaultMessage='Equal Opportunity Lender.'
          />
        )}
      </Text>
    </>
  )
}
